// Catálogo de las herramientas del menú del visor (NavDrawer). Única fuente de
// verdad compartida entre el menú y el formulario de crear/editar mapa (QA-11):
// una herramienta nueva se agrega acá y aparece sola en ambos lados.
export const MAP_TOOLS = [
  {
    "id": "layers",
    "icon": "layer-group",
    "label": "Capas"
  },
  // QA-204: la herramienta "Consulta" se eliminó del menú — el clic sobre una
  // capa activa muestra el popup de atributos sin abrir ninguna herramienta
  // (consulta por punto implícita, ver mapTools/select/Select.vue).
  {
    "id": "geoprocessing",
    "icon": "cogs",
    "label": "Geoproceso"
  },
  {
    "id": "legends",
    "icon": "list-alt",
    "label": "Simbología"
  },
  {
    "id": "shpKmzUpload",
    "icon": "file-import",
    "label": "Cargar Capas"
  },
  {
    "id": "wmsUpload",
    "icon": "globe",
    "label": "Subir WMS/WFS"
  },
  {
    "id": "search",
    "icon": "search",
    "label": "Buscador"
  },
  {
    "id": "locator",
    "icon": "location-arrow", //icono actualizado a "location-arrow" segun observacion de SENAPRED 06/2026 ("1. Herramienta de localizador sin símbolo")
    "label": "Localizador"
  },
  {
    "id": "annotations",
    "icon": "comment",
    "label": "Anotaciones"
  },
  {
    "id": "basemap",
    "icon": "map",
    label: "Mapas Base" //nombre actualizado segun observacion de SENAPRED 06/2026 ('La herramienta deberia llamarse "Mapas Base"')
  },
  {
    "id": "draw",
    "icon": "pen",
    "label": "Dibujar"
  },
  {
    "id": "measures",
    "icon": "ruler-combined",
    "label": "Medir mapa"
  },
  {
    "id": "print",
    "icon": "file-export",
    "label": "Exportar mapa"
  },
  {
    "id": "help",
    "icon": "question",
    "label": "Ayuda"
  }
]

// Herramientas que no se pueden deshabilitar. "layers" porque un mapa sin árbol
// de capas queda inutilizable y además se activa programáticamente (deep-link de
// campañas de terreno, flujo post-subida WMS); "help" porque el botón de ayuda
// fue pedido expresamente por SENAPRED (QA-45).
export const PROTECTED_MAP_TOOLS = ['layers', 'help']
